export default "__VITE_ASSET__Cesqr0$k__"